import { Card } from "@chakra-ui/react";
import CardAppConfig from "components/card/CardAppConfig";
import Loader from "components/loader/loader";
import Navbar from "components/navbar";
import { Formik } from "formik";
import { t } from "i18next";
import * as Yup from "yup";
import { createAppConfig } from "services/customAPI";
import { useNavigate } from "react-router-dom";
import { errorToast, successToast } from "utils/commons";

type formvalues = {
  name: string;
  value: string;
  placeHolder: string;
  active: boolean;
};
function CreateConfig() {
  const navigate = useNavigate();
  const initialFormValues = {
    name: "",
    value: "",
    placeHolder: "",
    active: true,
  };
  const appSchema = Yup.object().shape({});

  const isLoading = false;
  function handleCreateApp(values: formvalues): any {
    try {
      const response = createAppConfig(values);
      if (response) {
        successToast(t("salveConfigs"));
        navigate("/admin/settings/general/");
      }
    } catch (error: any) {
      errorToast(error.message);
      console.error("erro ao criar configurações", error.message);
    }
  }
  return (
    <>
      <div>
        <Navbar flag={false} brandText={t("Settings")} />
        {isLoading ? (
          <Loader />
        ) : (
          <Card className={"w-50 mt-4 h-full pb-10"}>
            <header className="relative flex items-center justify-between p-10">
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                {t("General")}
              </div>
            </header>
            <div className="pb-5 pe-20 ps-20" style={{ width: "100%" }}>
              <Formik
                enableReinitialize={true}
                initialValues={initialFormValues}
                onSubmit={(values) => handleCreateApp(values)}
                validationSchema={appSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="center grid w-full grid-cols-3 justify-between gap-8">
                      <CardAppConfig
                        handleChange={handleChange}
                        touched={touched}
                        values={values}
                        errors={errors}
                      />
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </Card>
        )}
      </div>
    </>
  );
}

export default CreateConfig;
